import { toast } from 'react-toastify';
import { ILocation } from 'src/models/location';
import { Address } from '../models/address';

export function validateEmail(email) {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export const mapAddressToLocation = (addressToMap: Address): ILocation => {
  const {
    address,
    city,
    latitude,
    longitude,
    num,
    formattedAddress,
    doorbel,
    _id,
  } = addressToMap;
  const body = {
    _id,
    address,
    city: city ? city : '',
    streetNumber: num,
    coordinates: {
      lat: latitude,
      lng: longitude,
    },
    doorbel,
    formattedAddress,
  };
  // @ts-ignore
  return body;
};

export const formatError = (err: any) => {
  if (err instanceof Error) {
    toast.error(err.message);
  } else {
    toast.error(err);
  }
};
